<template>
  <div class="realEstate-page">
    <div v-if="loaded === true">
      <!-- RealEstate statistics -->
      <b-row>
        <!--Managemnt details -->
        <b-col cols="12" class="col-12">
          <b-card no-body class="card-stats ">
            <b-card-body>
              <div>
                <div class="d-flex">
                  <feather-icon icon="PackageIcon" size="19"/>
                  <h4 class="mb-0 ml-50">
                    {{ msg('Whitelabel details').toUpperCase() }}
                  </h4>
                </div>
                <whitelabel-management v-model="whitelabel" @change="()=>whitelabelUpdated=true"/>
              </div>
            </b-card-body>
          </b-card>
        </b-col></b-row>


      <div class="update-realEstate" v-bind:class="{'active':(whitelabelUpdated===true)}">
        <b-button variant="primary" class="mx-1" @click="updateWhitelabel">{{ msg("Save") }}</b-button>
        <b-button variant="warning" @click="loadWhitelabel">{{ msg("Cancel") }}</b-button>
      </div>
    </div>
    <div v-else>
      <div class="d-flex align-items-center" style="min-height: 600px">
        <div class="d-inline-block w-100 text-center">
          <b-spinner class="mx-1" variant="primary"/>
          <strong>{{ msg('Loading') }}...</strong>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import WhitelabelManagement from '@/views/whitelabel/whitelabelManagement'

export default {
  name: 'editWhitelabel',
  components: {
    WhitelabelManagement,
  },
  data() {
    return {
      loaded: false,
      error: null,
      buid: null,
      whitelabel: {
        name: '',


      },
      dialogs: {
        client: false,
      },
      whitelabelUpdated: false,
      //Listeners
      listeners: {
        submit: () => {
        }
      },
    }
  },
  watch: {
    id: function () { // watch it
      this.onLoad()
      this.error = null
    },
  },
  computed: {
    ...mapGetters('translator', ['msg']),
    ...mapGetters('user', ['myAdminStatus','myRoleId']),
    ...mapGetters('data', ['getAllLanguage', 'getAllBranches', 'getAllCountries', 'getAdminRoleId']),
    canSubmit: {
      get() {
        return false
      },
      save(v) {
        this.$emit('update:canSave', v)
      }
    },
    allBranches() {
      return Object.values(this.getAllBranches)
    },
    isAdmin() {

      return this.myRoleId===1;
    }
  },
  created() {
    if (this.$route.params.id == null) {
      return this.error = 'Invalid whitelabel id'
    }
    this.id = this.$route.params.id;
    this.onLoad()
  },

  methods: {
    ...mapActions('whitelabel', {_getWhitelabel: 'getWhitelabelById', _updateWhitelabel: 'updateWhitelabel', _copyWhitelabel: 'copyWhitelabel'}),
    copyWhitelabel() {

      this._copyWhitelabel({whitelabel: this.whitelabel.id,buid:this.buid})
    },
    onLoad() {
      this.loaded = false

      this.loadWhitelabel()

    },

    loadWhitelabel() {
      let $this = this
      $this.loaded = false
      this._getWhitelabel($this.id)
          .then((whitelabel) => {

            $this.whitelabel = whitelabel
            //Set page as loaded
            $this.loaded = true
            $this.whitelabelUpdated = false;
          }, (error) => {
            $this.error = error
          })
    }
    ,

    updateWhitelabel() {
      let $this = this
      this._updateWhitelabel(this.whitelabel)
          .then(
              (a) => $this.$emit('submitted', {
                status: true,
                server: a
              }),
              (a) => $this.$emit('submitted', {
                status: false,
                server: a
              })
          )
    },
    validate(field) {
      return this.$v.whitelabel[field] != null && this.$v.whitelabel[field].$error === true
    },
    submit() {
      if (this.id !== 0) {
        return this.updateWhitelabel()
      }
      return this.createWhitelabel()

    },


  },

}
</script>

<style>
.realEstate-page .update-realEstate {
  position: fixed;
  bottom: 5%;
  z-index: 100;
  transition: all 0.5s ease;
  right: 79px;
  opacity: 0;
}

.realEstate-page .update-realEstate.active {
  opacity: 1;
}

.realEstate-page .update-realEstate .btn-primary {
  -webkit-box-shadow: 0 1px 20px 1px #7367f0 !important;
  box-shadow: 0 1px 20px 1px #7367f0 !important;
}

.realEstate-page .update-realEstate .btn-warning {
  -webkit-box-shadow: 0 1px 20px 1px #ff8510 !important;
  box-shadow: 0 1px 20px 1px #ff8510 !important;
}

.realEstate-page .dz-preview, .dz-file-preview {
  display: none;
}
</style>
